<template>
	<expose class="game-video-expose" :active="videoId != null" v-on:expose-close="$root.$data.gameVideoId = null">
		<game-video class="game-video-expose__video" ref="videoWindow" :videoId="videoId" v-bind:style="{
			'width' : videoWidth + 'px'
		}"></game-video>
	</expose>
</template>

<script>
import Expose from '../molecules/Expose'
import GameVideo from '../molecules/GameVideo'

export default {
	name: 'GameVideoExpose',
	components: {
		Expose,
		GameVideo
	},
	data () {
		return {
			aspectRatio: (540/960),
			spacing: 40
		}
	},
	props: {
		videoId: String
	},
	computed: {
		videoWidth: function()
		{
			var self = this;
			var videoWindow = self.$refs.videoWindow;
			var winWidth = self.$root.$data.windowWidth;
			var winHeight = self.$root.$data.windowHeight;
			var winAspectRatio = winHeight / winWidth;
			var chosenAR = Math.max(self.aspectRatio, winAspectRatio);

			return Math.min(1080, (winHeight - (2 * self.spacing)) * (1 / chosenAR));
		}
	},
	created: function()
	{
	},
	mounted: function()
	{
	},
	methods: {
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".game-video-expose";
	#{$c}
	{
		&__video
		{
			max-width: 1080px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/organisms/GameVideoExpose.vue